export default "__VITE_ASSET__BLwgh5Dw__"